import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config-global";
import { PATH_DASHBOARD } from "./paths";
import MainLayout from "src/layouts/main";
//
import {
  // Auth
  LoginPage,
  ImpersonationPage,

  // Dashboard: General
  GeneralAppPage,

  // Dashboard: Report
  GeneralReportPage,

  // Dashboard: Staff
  UserListPage,
  UserEditPage,
  UserCreatePage,

  // DASHBOARD: STOCK
  AllStockListPage,
  LiveStockListPage,
  AllAdjustmentListPage,
  AllPurchaseOrderListPage,
  AddAdjustmentPage,
  AddPurchaseOrderPage,
  AdjustmentEditPage,
  PurchaseOrderEditPage,
  StockRequestListPage,
  StockRequestDetailPage,
  StockTransferListPage,
  StockTransferCreatePage,
  StockTransferDetailPage,
  StockReturnListPage,
  StockReturnDetailPage,
  InventoryListPage,
  StoreListPage,
  StoreItemListPage,
  StoreFormPage,
  AccountsPurchasedOrderListPage,
  AccountsPurchasedOrderCreatePage,
  AccountsPurchasedOrderEditPage,
  AccountsPurchasedOrderDetailPage,
  AccountsGoodReceiptNoteListPage,
  AccountsGoodReceiptNoteCreatePage,
  AccountsGoodReceiptNoteEditPage,
  AccountsGoodReceiptNoteDetailPage,
  AccountsApInvoiceListPage,
  AccountsApInvoiceCreatePage,
  AccountsApInvoiceEditPage,
  AccountsApInvoiceDetailPage,
  AccountsBankingListPage,
  AccountsBankingCreatePage,
  AccountsBankingEditPage,
  AccountsBankingDetailPage,
  AccountsBankingReturnListPage,
  AccountsBankingReturnCreatePage,
  AccountsBankingReturnEditPage,
  AccountsBankingReturnDetailPage,
  AccountsAdvancePaymentListPage,
  AccountsAdvancePaymentCreatePage,
  AccountsAdvancePaymentEditPage,
  AccountsAdvancePaymentDetailPage,
  AccountsAdvancePaymentReturnListPage,
  AccountsAdvancePaymentReturnCreatePage,
  AccountsAdvancePaymentReturnEditPage,
  AccountsAdvancePaymentReturnDetailPage,
  AccountsPurchaseOrderReturnListPage,
  AccountsPurchaseOrderReturnCreatePage,
  AccountsPurchaseOrderReturnEditPage,
  AccountsPurchaseOrderReturnDetailPage,
  AccountsGoodReceiptNoteReturnListPage,
  AccountsGoodReceiptNoteReturnCreatePage,
  AccountsGoodReceiptNoteReturnEditPage,
  AccountsGoodReceiptNoteReturnDetailPage,
  AccountsApInvoiceReturnListPage,
  AccountsApInvoiceReturnCreatePage,
  AccountsApInvoiceReturnEditPage,
  AccountsApInvoiceReturnDetailPage,
  AddStockPage,
  AllStockEditPage,

  //DASHBOARD: INGREDIENT
  IngredientListPage,
  IngredientCreatePage,
  IngredientEditPage,

  //DASHBOARD: INVOICE
  InvoiceListPage,

  // DASHBOARD: CATALOG
  CategoryListPage,
  CategoryDetailPage,
  ProductListPage,
  ProductDetailPage,

  // Dashboard: Desigination
  DesiginationCreatePage,
  DesiginationEditPage,

  // Dashboard: Settings
  SettingsCreatePage,
  UserAccountPage,

  // Other
  Page500,
  Page403,
  Page404,

  // Supplier
  SupplierListPage,
  SupplierCreatePage,
  SupplierEditPage
} from "./elements";
import PrivateRoute from "./PrivateRoute";
export default function Router() {
  return useRoutes([
    {
      path: "impersonate",
      element: <ImpersonationPage />,
    },
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "app",
          element: (
            <PrivateRoute
              component={GeneralAppPage}
              permission="canViewDashboard"
            />
          ),
        },
        {
          path: "report",
          element: (
            <PrivateRoute
              component={GeneralReportPage}
              permission="canAccessReports"
            />
          ),
        },
        {
          path: "hrm",
          children: [
            {
              index: true,
              element: <Navigate to={PATH_DASHBOARD.hrm.staff} replace />,
            },
            {
              path: "staff",
              element: (
                <PrivateRoute
                  component={UserAccountPage}
                  permission="canViewStaff"
                />
              ),
            },
            {
              path: "dashboard",
              element: (
                <PrivateRoute
                  component={UserAccountPage}
                  permission="canViewStaff"
                />
              ),
            },
            {
              path: ":id/view",
              element: (
                <PrivateRoute
                  component={UserEditPage}
                  permission="canViewStaff"
                />
              ),
            },
          ],
        },
        {
          path: "user",
          children: [
            {
              element: <Navigate to="/dashboard/user/profile" replace />,
              index: true,
            },
            { path: "list", element: <UserListPage /> },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={UserCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: <UserEditPage />,
            },
            {
              path: ":id/replicate",
              element: <UserEditPage />,
            },
            {
              path: "account",
              element: <Navigate to={PATH_DASHBOARD.hrm.staff} replace />,
             
            },
          ],
        },

        {
          path: "stock",
          children: [
            { path: "display", element: <AllStockListPage /> },
            { path: "live", element: <LiveStockListPage /> },
            { path: "adjustment", element: <AllAdjustmentListPage /> },
            { path: "purchaseOrders", element: <AllPurchaseOrderListPage /> },

            {
              path: "adjustment/new",
              element: <PrivateRoute component={AddAdjustmentPage} />,
            },

            {
              path: "purchaseOrders/new",
              element: <PrivateRoute component={AddPurchaseOrderPage} />,
            },

            {
              path: "new",
              element: <PrivateRoute component={AddStockPage} />,
            },
            {
              path: ":id/edit",
              element: <AllStockEditPage />,
            },
            {
              path: "adjustment/:id/edit",
              element: <AdjustmentEditPage />,
            },

            {
              path: "purchaseOrders/:id/edit",
              element: <PurchaseOrderEditPage />,
            },
          ],
        },

        {
          path: "stocks",
          children: [
            { path: "requests", element: <StockRequestListPage /> },
            { path: "requests/:id", element: <StockRequestDetailPage /> },
            { path: "transfers", element: <StockTransferListPage /> },
            { path: "transfers/new", element: <StockTransferCreatePage /> },
            { path: "transfers/:id", element: <StockTransferDetailPage /> },
            { path: "returns", element: <StockReturnListPage /> },
            { path: "returns/:id", element: <StockReturnDetailPage /> },
          ],
        },

        {
          path: "inventory",
          children: [{ index: true, element: <InventoryListPage /> }],
        },

        {
          path: "stores-item",
          element: <StoreItemListPage />,
        },

        {
          path: "stores",
          children: [
            { index: true, element: <StoreListPage /> },
            { path: "new", element: <StoreFormPage /> },
            { path: ":inventoryStoreId/edit", element: <StoreFormPage /> },
          ],
        },

        {
          path: "item",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: <PrivateRoute component={IngredientListPage} />,
            },
            { path: "new", element: <IngredientCreatePage /> },

            {
              path: ":id/edit",
              element: <PrivateRoute component={IngredientEditPage} />,
            },
          ],
        },

        {
          path: "supplier",
          children: [
            {
              path: "list",
              element: (
                <PrivateRoute
                  component={SupplierListPage}
                  permission="canViewSuppliers"
                />
              ),
            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={SupplierCreatePage}
                  permission="canAddAndEditSuppliers"
                />
              ),
            },

            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={SupplierEditPage}
                  permission="canAddAndEditSuppliers"
                />
              ),
            },
          ],
        },

        {
          path: "catalog",
          children: [
            {
              element: <Navigate to="/dashboard/catalog/categories" replace />,
              index: true,
            },
            {
              path: "categories",
              element: <CategoryListPage />,
            },
            {
              path: "categories/:id/edit",
              element: <CategoryDetailPage />,
            },
            {
              path: "products",
              element: <ProductListPage />,
            },
            {
              path: "products/:id/edit",
              element: <ProductDetailPage />,
            },
          ],
        },

        {
          path: "accounts",
          children: [
            {
              element: (
                <Navigate to="/dashboard/accounts/purchased-order" replace />
              ),
              index: true,
            },
            {
              path: "purchased-order",
              element: (
                <PrivateRoute component={AccountsPurchasedOrderListPage} />
              ),
            },
            {
              path: "purchased-order/new",
              element: (
                <PrivateRoute component={AccountsPurchasedOrderCreatePage} />
              ),
            },
            {
              path: "purchased-order/:id",
              element: (
                <PrivateRoute component={AccountsPurchasedOrderDetailPage} />
              ),
            },
            {
              path: "purchased-order/:id/edit",
              element: (
                <PrivateRoute component={AccountsPurchasedOrderEditPage} />
              ),
            },
            {
              path: "good-receipt-note",
              element: (
                <PrivateRoute component={AccountsGoodReceiptNoteListPage} />
              ),
            },
            {
              path: "good-receipt-note/new",
              element: (
                <PrivateRoute component={AccountsGoodReceiptNoteCreatePage} />
              ),
            },
            {
              path: "good-receipt-note/:id",
              element: (
                <PrivateRoute component={AccountsGoodReceiptNoteDetailPage} />
              ),
            },
            {
              path: "good-receipt-note/:id/edit",
              element: (
                <PrivateRoute component={AccountsGoodReceiptNoteEditPage} />
              ),
            },
            {
              path: "ap-invoice",
              element: <PrivateRoute component={AccountsApInvoiceListPage} />,
            },
            {
              path: "ap-invoice/new",
              element: <PrivateRoute component={AccountsApInvoiceCreatePage} />,
            },
            {
              path: "ap-invoice/:id",
              element: <PrivateRoute component={AccountsApInvoiceDetailPage} />,
            },
            {
              path: "ap-invoice/:id/edit",
              element: <PrivateRoute component={AccountsApInvoiceEditPage} />,
            },
            {
              path: "banking",
              element: <PrivateRoute component={AccountsBankingListPage} />,
            },
            {
              path: "banking/new",
              element: <PrivateRoute component={AccountsBankingCreatePage} />,
            },
            {
              path: "banking/:id",
              element: <PrivateRoute component={AccountsBankingDetailPage} />,
            },
            {
              path: "banking/:id/edit",
              element: <PrivateRoute component={AccountsBankingEditPage} />,
            },
            {
              path: "banking-return",
              element: (
                <PrivateRoute component={AccountsBankingReturnListPage} />
              ),
            },
            {
              path: "banking-return/new",
              element: (
                <PrivateRoute component={AccountsBankingReturnCreatePage} />
              ),
            },
            {
              path: "banking-return/:id",
              element: (
                <PrivateRoute component={AccountsBankingReturnDetailPage} />
              ),
            },
            {
              path: "banking-return/:id/edit",
              element: (
                <PrivateRoute component={AccountsBankingReturnEditPage} />
              ),
            },
            {
              path: "advance-payment",
              element: (
                <PrivateRoute component={AccountsAdvancePaymentListPage} />
              ),
            },
            {
              path: "advance-payment/new",
              element: (
                <PrivateRoute component={AccountsAdvancePaymentCreatePage} />
              ),
            },
            {
              path: "advance-payment/:id",
              element: (
                <PrivateRoute component={AccountsAdvancePaymentDetailPage} />
              ),
            },
            {
              path: "advance-payment/:id/edit",
              element: (
                <PrivateRoute component={AccountsAdvancePaymentEditPage} />
              ),
            },
            {
              path: "advance-payment-return",
              element: (
                <PrivateRoute
                  component={AccountsAdvancePaymentReturnListPage}
                />
              ),
            },
            {
              path: "advance-payment-return/new",
              element: (
                <PrivateRoute
                  component={AccountsAdvancePaymentReturnCreatePage}
                />
              ),
            },
            {
              path: "advance-payment-return/:id",
              element: (
                <PrivateRoute
                  component={AccountsAdvancePaymentReturnDetailPage}
                />
              ),
            },
            {
              path: "advance-payment-return/:id/edit",
              element: (
                <PrivateRoute
                  component={AccountsAdvancePaymentReturnEditPage}
                />
              ),
            },
            {
              path: "po-return",
              element: (
                <PrivateRoute component={AccountsPurchaseOrderReturnListPage} />
              ),
            },
            {
              path: "po-return/new",
              element: (
                <PrivateRoute
                  component={AccountsPurchaseOrderReturnCreatePage}
                />
              ),
            },
            {
              path: "po-return/:id",
              element: (
                <PrivateRoute
                  component={AccountsPurchaseOrderReturnDetailPage}
                />
              ),
            },
            {
              path: "po-return/:id/edit",
              element: (
                <PrivateRoute component={AccountsPurchaseOrderReturnEditPage} />
              ),
            },
            {
              path: "grn-return",
              element: (
                <PrivateRoute
                  component={AccountsGoodReceiptNoteReturnListPage}
                />
              ),
            },
            {
              path: "grn-return/new",
              element: (
                <PrivateRoute
                  component={AccountsGoodReceiptNoteReturnCreatePage}
                />
              ),
            },
            {
              path: "grn-return/:id",
              element: (
                <PrivateRoute
                  component={AccountsGoodReceiptNoteReturnDetailPage}
                />
              ),
            },
            {
              path: "grn-return/:id/edit",
              element: (
                <PrivateRoute
                  component={AccountsGoodReceiptNoteReturnEditPage}
                />
              ),
            },
            {
              path: "ap-invoice-return",
              element: (
                <PrivateRoute component={AccountsApInvoiceReturnListPage} />
              ),
            },
            {
              path: "ap-invoice-return/new",
              element: (
                <PrivateRoute component={AccountsApInvoiceReturnCreatePage} />
              ),
            },
            {
              path: "ap-invoice-return/:id",
              element: (
                <PrivateRoute component={AccountsApInvoiceReturnDetailPage} />
              ),
            },
            {
              path: "ap-invoice-return/:id/edit",
              element: (
                <PrivateRoute component={AccountsApInvoiceReturnEditPage} />
              ),
            },
          ],
        },

        {
          path: "invoice",
          children: [
            {
              path: "list",
              element: <PrivateRoute component={InvoiceListPage} />,
            },
          ],
        },

        {
          path: "desigination",
          children: [
            {
              element: <Navigate to="/dashboard/user/account" replace />,
              index: true,
            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={DesiginationCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={DesiginationEditPage}
                  permission="canEditStaffDetails"
                />
              ),
            },
          ],
        },

        {
          path: "settings",
          children: [
            {
              element: <Navigate to="/dashboard/settings/new" replace />,
              index: true,
            },
            { path: "new", element: <SettingsCreatePage /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: "500", element: <Page500 /> },
        { path: "404", element: <Page404 /> },
        { path: "403", element: <Page403 /> },
      ],
    },
    {
      element: <MainLayout />,
      children: [
        {
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
          index: true,
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
